// GENERATED FILE - DO NOT MODIFY
export enum GridStateType {
    Column = 0,
    Filter = 1,
    Sort = 2,
}

export let nameof = "GridStateType";
